const urlName = '/order/v1'
export default API => ({
    // 查询商品详情
    findGoodsDetailById(data) {
        return API({
            url:`${urlName}/open/entityGoods/detail`,
            data,
            method:'post',
        });
    },
    //实物商品下单
    orderEntityGoods(data) {
        return API({
            url:`${urlName}/open/order/selectEntityGoods`,
            data,
            method:'post',
        });
    },
    //推荐商品列表
    getEntityGoodslist(data) {
        return API({
            url: `${urlName}/open/entityGoods/list`,
            data,
            method:'post'
        })
    },
    //推荐课程商品列表
    findMallGoodsList(params,data) {
        return API({
            url: `${urlName}/trainingGoodsMall/findMallGoodsList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
            data,
            method:'post'
        })
    },
    // 获短视频详情
    detail(data) {
        return API({
            url: `/short_video/v1/client/detail`,
            method: 'post',
            data,
        });
    },
    // 视频获取播放凭证--h5和app端免登陆播放
    videoPlayAuth(data) {
        return API({
            url: `/short_video/v1/client/playAuthByVideoId?videoId=${data.shortVideoId}&hashCover=${data.hashCover}`,
            method: 'get',
            // data,
        });
    },
    //获取入驻机构域名
	getSaasBranchDomain(branchId) {
		return API({
			url: `/modular/admin/v1/saasBranchDomain/${branchId}`,
		})
	},
     // 根据机构返回机构基本信息
     getBranchInformationByBid(params) {
        return API({
            url: `/cms/v1/information/getBranchInformationByBid` ,
            method:  'post',
            params,
        });
    },
})
  